import { WarningCircle } from "@phosphor-icons/react";
import { useAccessGuard } from "../context/AccessGuardContext";

interface ConnectionWarningBannerProps {
  tone?: "site" | "app";
}

export function ConnectionWarningBanner({ tone = "site" }: ConnectionWarningBannerProps) {
  const { showVpnWarning } = useAccessGuard();

  if (!showVpnWarning) {
    return null;
  }

  return (
    <div
      className={[
        "relative z-30 mx-auto w-full max-w-[1440px] px-4",
        tone === "app" ? "pb-3 pt-4" : "pb-2 pt-3"
      ].join(" ")}
    >
      <div
        className={[
          "flex items-start gap-3 rounded-[1.6rem] border px-4 py-3 shadow-[0_22px_52px_-34px_rgba(0,0,0,0.32)]",
          tone === "app"
            ? "border-amber-500/24 bg-[linear-gradient(160deg,rgba(120,52,19,0.96)_0%,rgba(78,28,10,0.98)_100%)] text-amber-50"
            : "border-amber-400/28 bg-[linear-gradient(160deg,rgba(255,247,230,0.96)_0%,rgba(250,236,206,0.98)_100%)] text-stone-900"
        ].join(" ")}
      >
        <span
          className={[
            "mt-0.5 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full",
            tone === "app" ? "bg-white/10 text-amber-100" : "bg-amber-500/12 text-amber-800"
          ].join(" ")}
        >
          <WarningCircle size={18} weight="fill" />
        </span>

        <div className="space-y-1">
          <p className="text-sm font-semibold tracking-tight">VPN мешает стабильной работе сервиса</p>
          <p className={["text-sm leading-6", tone === "app" ? "text-amber-50/88" : "text-stone-700"].join(" ")}>
            Выключите VPN и перезайдите для стабильной работы. Некоторые разделы и фотографии могут не работать с VPN.
            Сервис рассчитан только на российские IP.
          </p>
        </div>
      </div>
    </div>
  );
}
